<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="index">
      <label class="question-option">
        <input
          ref="input"
          type="radio"
          :value="option.title"
          v-model="val">
        {{ option.title }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    val: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
